import script from "./blockPersonalCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./blockPersonalCreate.vue?vue&type=script&setup=true&lang=ts"

import "./blockPersonalCreate.vue?vue&type=style&index=0&id=5b590982&lang=less&scoped=true"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b590982"]])

export default __exports__